<template>
  <b-row>
    <b-col
      :md="10"
      :offset-md="1"
    >
      <b-row v-if="user">
        <b-col>
          <crosses-section
            ref="crossCollateral"
            :form="basicDeal"
          />
          <b-row v-if="showDetailsForm">
            <b-col>
              <hr/>
              <vue-form-generator
                :model="basicDeal"
                :schema="schema"
                :options="formOptions"
                ref="detailsForm"
              >
              </vue-form-generator>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-else>
        <b-col>
          <address-form-fields
            ref="addressSection"
            :form="basicDeal.property.address"
            @address-updated="basicDeal.property.address = $event"
          >
          </address-form-fields>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import VueFormGenerator from 'vue-form-generator';
import CrossesSection from '@/components/new_deal/components/property/crosses/CrossesSection';
import AddressFormFields from '@/components/utils/address/AddressFormFields';

import schemaDefinition from './schema';


export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    CrossesSection,
    AddressFormFields,
  },
  props: {
    basicDeal: Object,
  },
  data() {
    return {
      schema: schemaDefinition.schema,
      formOptions: schemaDefinition.formOptions,
      isMounted: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    showDetailsForm() {
      if (!this.isMounted) {
        return false;
      }
      const crossCollateral = this.$refs.crossCollateral;
      return crossCollateral && crossCollateral.$refs.searchProp.hasSelectedProperties;
    },
  },
  methods: {
    validate() {
      const $refs = this.$refs;
      if (this.user) {
        const isCrossCollateralValid = $refs.crossCollateral.$refs.searchProp.validate();
        const isDetailsValid = $refs.detailsForm && $refs.detailsForm.validate();
        return isCrossCollateralValid && isDetailsValid;
      }

      return $refs.addressSection.validate();
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/new_deal/components/property/PropertySection.vue